
export class WorkTask {
    id?: number;
    taskName?: string;
    taskImage?: string;
    taskOrderKey?: number;
    workTaskGroupId?: number;
}